/**
 * Recharge (and similar apps) update Shopify’s `selling_plan` inputs on the PDP.
 * We don’t get direct “widget click” events from app JS, but we can detect the *result*:
 * empty selling_plan ≈ one-time, non-empty ≈ subscription.
 *
 * Dispatches (bubbles on the product <section>):
 *   CustomEvent "brocshot:purchase-type"
 *   detail: { sectionId, is_Onetime: boolean|null, sellingPlanValue, hasSellingPlanField }
 *
 * is_Onetime null = no selling_plan control found yet (ignore for UI).
 */
;(function () {
  const ATTR = 'data-brocshot-selling-plan-sync'

  function planSelectors() {
    return 'input[name="selling_plan"],select[name="selling_plan"],input.selling_plan-id,input[name^="selling_plan"]'
  }

  function collectPlanFields(form, sectionEl) {
    const out = []
    const seen = new Set()

    function add(el) {
      if (el && !seen.has(el)) {
        seen.add(el)
        out.push(el)
      }
    }

    if (form?.elements?.namedItem) {
      const n = form.elements.namedItem('selling_plan')
      if (n) {
        if (typeof n.length === 'number' && n[0]) {
          for (let i = 0; i < n.length; i++) add(n[i])
        } else add(n)
      }
    }

    form?.querySelectorAll(planSelectors()).forEach(add)
    sectionEl?.querySelectorAll(planSelectors()).forEach(add)

    return out
  }

  function primaryValue(fields) {
    for (const el of fields) {
      const v = String(el.value ?? '').trim()
      if (v !== '') return v
    }
    return ''
  }

  function emit(sectionEl, sectionId, fields) {
    const has = fields.length > 0
    const value = has ? primaryValue(fields) : ''
    const isOnetime = has ? value === '' : null

    const detail = {
      sectionId,
      is_Onetime: isOnetime,
      hasSellingPlanField: has,
      sellingPlanValue: value || null,
    }

    sectionEl.dispatchEvent(new CustomEvent('brocshot:purchase-type', { detail, bubbles: true }))
    window.dispatchEvent(new CustomEvent('brocshot:purchase-type', { detail }))
  }

  function attach(sectionEl) {
    if (!sectionEl || sectionEl.getAttribute(ATTR)) return

    const sectionId = sectionEl.dataset.sectionId
    if (!sectionId) return

    const form = document.getElementById('product-form-' + sectionId)
    if (!form) return

    sectionEl.setAttribute(ATTR, '')

    const run = () => emit(sectionEl, sectionId, collectPlanFields(form, sectionEl))

    form.addEventListener('change', run, true)
    form.addEventListener('input', run, true)
    sectionEl.addEventListener('change', run, true)
    sectionEl.addEventListener('input', run, true)

    const mo = new MutationObserver(() => run())
    mo.observe(sectionEl, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['value', 'checked'],
    })

    run()
  }

  function tryAttach(sectionEl, attempt) {
    const n = attempt || 0
    const sectionId = sectionEl?.dataset?.sectionId
    if (!sectionId) return
    const form = document.getElementById('product-form-' + sectionId)
    if (!form) {
      if (n < 30) setTimeout(() => tryAttach(sectionEl, n + 1), 150)
      return
    }
    attach(sectionEl)
  }

  function boot() {
    document.querySelectorAll('section.page-content--product[data-section-id]').forEach((sectionEl) => {
      if (sectionEl.getAttribute(ATTR)) return
      tryAttach(sectionEl, 0)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }

  document.addEventListener('shopify:section:load', () => {
    requestAnimationFrame(() => {
      document.querySelectorAll('section.page-content--product[data-section-id]').forEach((el) => {
        el.removeAttribute(ATTR)
      })
      boot()
    })
  })
})()
